import styled from "styled-components"

export const TxtFile = styled.div`
    padding: 3rem;
    overflow-y: auto;
    overflow-x: auto;
    font-family: "Roboto Mono", monospace;
    width: 100%;
    height: 100%;
`

export const BodyTxt = styled.span`
    font-family: "Roboto Mono", monospace;
    width: 80%;
    white-space: pre;
`



// WEBPACK FOOTER //
// ./src/OctoprintParser/ShowTxtFile/styles.js